import React, {useEffect, useState} from 'react';
import ethereum from 'decentralized/ethereum.js';
import {connect} from 'react-redux';

const SequenceEdits = ({work, allSequences}) => {
    const [edits, setEdits] = useState([]);

    useEffect(() => {
        let e = ethereum.getEditsForSequence(work.newSequence, allSequences);
        console.log('edits = ', e);
        setEdits(e);
    }, [setEdits, work, allSequences]);

    const createNewEdit = () => {
        window.open("/create/" + work.newSequence);
    };

    return (
        <div>
          <div className="sequence-edits">
            {edits.map(
                e =>
                    <SequenceEdit edit={e}/>)}
         </div>
          <div
            onClick={createNewEdit}
            className="new-edit-button">
            Create New Edit
          </div>
        </div>
    );
};

const SequenceEdit = ({edit}) => {
    const [userName, setUserName] = useState('');
    const [date, setDate] = useState('');

    useEffect(() => {
        ethereum.users.getUserName(edit.user).then(
            name => setUserName(name));
    }, [edit, setUserName]);

    useEffect(() => {
        ethereum.getBlockDate(edit.blockNumber)
            .then(d => setDate(d.toISOString().substring(0,10)));
    }, [setDate, edit]);

    return (
        <div className="sequence-edit">
          <div className="title">
            {edit.title} -  
          </div>
          <div className="author">
            {userName}
          </div>
          <div className="date">
            {date}
          </div>
        </div>
    );
};


const mapStateToProps = (state, props) => {
    return {
        allSequences: state.explore.allSequences
    };
};

export default connect(mapStateToProps, null)(SequenceEdits);
